import { render, staticRenderFns } from "./policy-rules.vue?vue&type=template&id=5187a037&scoped=true&"
import script from "./policy-rules.vue?vue&type=script&lang=js&"
export * from "./policy-rules.vue?vue&type=script&lang=js&"
import style0 from "./policy-rules.vue?vue&type=style&index=0&id=5187a037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187a037",
  null
  
)

export default component.exports